<template>
<modal name="yagish-dialog"
  :adaptive="true"
  :scrollable="true"
  height="auto">
  <div class="v--modal-close-top" v-loading.fullscreen.lock="fullscreenLoading">
    <el-button @click="closeYagishDialog"
      icon="el-icon-circle-close-outline"
      style="font-size: 2rem;"
      type="text"></el-button>
  </div>
  <div class="setting" v-if="permissionType == 5">
          <div style="text-align: center;">
                  <p style="line-height: 1.4;">ヤギッシュからのお知らせ<br><span style="font-weight: bold; font-size: 120%;">急成長のためスタッフ募集！</span></p>
                  
                  <div style="padding: 15px 15px 30px 15px; background: #EFF8F8;  margin: 15px auto;">
                          <p>現在の募集職種</p>
                          <div>
                                  <h3 style="font-size: 120%; margin-top: -5px; padding-top: 0;">営業</h3>
                                  <p style="text-align: left;"><span style="font-weight: bold; margin-top: 10px;">延べ、500万人以上に使われている日本最大級履歴書作成サービス</span>をベースとして、営業力を強化するため、あなたの参加をお待ちしています！</p>
                                  <p style="text-align: left; padding-top: 10px;"><span style="font-weight: bold;">仕事内容</span><br>
                                          求職者と求人会社のマッチング営業（未経験者歓迎）</p>
                                  <p style="text-align: left; padding-top: 10px;"><span style="font-weight: bold;">待遇</span><br>
                                          現在30歳平均年俸550万円<br>(3年後平均年俸1,000万円目標)
                                          </p>
                                  <a href="https://www.yagish.jp/recruit/" target="_blank" style="font-size: 70%;">ヤギッシュについて</a>
                          </div>
                  </div>

                    <el-button id="send-adtop-pdf" type="success" v-if="isYagishSended == false"
                    style="background-color: #E3165C; border-color: #E3165C; font-size: 120%;"
                      @click="$eventHub.$emit('send-yagish-consult');"><span style="font-size: 80%; line-height: 1rem;">応募する</span></el-button>
                    <el-button id="send-adtop-pdf" type="success" v-else
                    style="background-color:#0F9934;border-color:#0F9934;"
                      @click="closeYagishDialog();"><span style="font-size: 80%; line-height: 1rem;">送信しました</span></el-button>

          </div>
  </div>
  <div class="setting" v-else-if="permissionType == 6">
          <div style="text-align: center;">
                  <p style="line-height: 1.4;">ヤギッシュからのお知らせ<br><span style="font-weight: bold; font-size: 120%;">急成長のためスタッフ募集！</span></p>
                  
                  <div style="padding: 15px 15px 30px 15px; background: #EFF8F8;  margin: 15px auto;">
                          <p>現在の募集職種</p>
                          <div>
                                  <h3 style="font-size: 120%; margin-top: -5px; padding-top: 0;">ディレクター</h3>
                                  <p style="text-align: left; padding-top: 10px;">500万人以上に使われている急成長中履歴書作成サイトを、あなたの力でさらに進化させてください！<span style="font-weight: bold;">さまざまな経験を積んだスペシャリストたちと一緒に、このサービスを日本一、アジア一にしましょう。</span><br>※ご経験により前職給与以上をご提示いたします。</p>
                                  <a href="https://www.yagish.jp/recruit/" target="_blank" style="font-size: 70%;">ヤギッシュについて</a>
                          </div>
                  </div>

                    <el-button id="send-adtop-pdf" type="success" v-if="isYagishSended == false"
                    style="background-color: #E3165C; border-color: #E3165C; font-size: 120%;"
                      @click="$eventHub.$emit('send-yagish-consult');"><span style="font-size: 80%; line-height: 1rem;">応募する</span></el-button>
                    <el-button id="send-adtop-pdf" type="success" v-else
                    style="background-color:#0F9934;border-color:#0F9934;"
                      @click="closeYagishDialog();"><span style="font-size: 80%; line-height: 1rem;">送信しました</span></el-button>
          </div>
  </div>


  <div class="text-right">
    <el-button @click="closeYagishDialog">닫기</el-button>
  </div>
</modal>
</template>
<style lang="scss" src="@/assets/scss/pages/pages.scss"></style>
<style lang="scss" src="@/assets/scss/pages/setting.scss"></style>
<script>
export default {
  components: {
  },
  data: function () {
    return {
      clearLocalStorageConfirmVisible: false,
      currentFormat: {},
      formatid: '',
      previewHtml: '',
      permissionType: 1,
      isYagishSended:false,
      isMedlySended:false,
      isAdtopSended:false,
      isJigenSended:false,
      fullscreenLoading:false,
      username:'',
      baite_title:'バイト',
      isAgree:true
    }
  },
  created : function(){
    const app = this
    this.$iterateStorage(function (value, key, iterationNumber) {
        //console.log all the kay/value pairs
        if (key === 'basicData') {
          app.username = value.lastName + '_' + value.firstName
        }
    }, function (err) {
        if (!err) {
            console.log('Iteration has completed');
        }
    })
  },
  computed: {
    cleanedPreviewHtml: function () {
      // PDFで文字化けするやつを変換しておく
      return this.previewHtml
    },
    pdfFormData: function () {
      const formData = new FormData()
      formData.append('app_html', this.cleanedPreviewHtml)
      formData.append('pdf_option', 'A4')
      return formData
    }
  },
  methods: {
    openYagishDialog: function (id, html, permissionType) {
      this.formatid = id
      this.previewHtml = html.$el.innerHTML
      this.$modal.show('yagish-dialog')
      this.clearLocalStorageConfirmVisible = false
      this.permissionType = permissionType

      const formData = new FormData()
      formData.append('uuid', this.$firebase.user.uid)
      formData.append('format_id', this.formatid)
      formData.append('dialog_name', 'yagish_dialog')
      formData.append('permission_type', this.permissionType)
      formData.append('device_flg', this.$deviceLib.isMobileDevice ? 'SP': 'PC')
      formData.append('version', '2')
      formData.append('site_flag', 'c')
      formData.append('app_flag', this.$site.appFlag)
      const app = this
      this.$axios.post(this.$varuna.endPoints.displayDialog, formData, {timeout: 60000})
      this.$iterateStorage(function (value, key, iterationNumber) {
          //console.log all the kay/value pairs
          if (key === 'basicData') {
            app.username = value.lastName + '_' + value.firstName
          }
      }, function (err) {
          if (!err) {
              console.log('Iteration has completed');
          }
      })
    },
    closeYagishDialog: function () {
      this.$modal.hide('yagish-dialog')
      this.clearLocalStorageConfirmVisible = false
      //this.$router.push('/mypage')
    },
    confirmWin: function () {
      confirm('応募するデータを送信します。よろしいでしょうか。')
    },
    clearLocalStorage: function () {
      this.$clearStorage()
      window.location = '/'
    },
    createFilename: function (ext) {
      const now = new Date()
      const prefix = process.env.VUE_APP_DOWNLOAD_FILENAME_PREFIX
      const dateString = this.$formLib.dateFormat(now, '_yyyy-mm-dd_HH-MM-ss')
      return `${prefix}${this.formatid}${dateString}.${ext}`
    },
    sendYagishConsult: async function () {
      if (!this.isAgree) {
        this.$message({
          message: 'チェックしてから同意ボタンを押してください。',
          type: 'error'
        })
        return
      }
      if (!this.$deviceLib.isOnline) {
        this.$message({
          message: '오프라인입니다. 인터넷에 접속 해주세요.',
          type: 'warning'
        })
        return
      }
      await this.$firebase.reloadToken()
      const accessToken = this.$firebase.accessToken
      if (!accessToken || !this.$firebase.user.email) {
        this.$message({
          message: '로그인 해주세요.',
          type: 'warning'
        })
        return
      }
      this.fullscreenLoading = true
      
      const formData = this.pdfFormData
      formData.append('token', accessToken)
      formData.append('apikey', this.$firebase.config.apiKey)
      formData.append('uuid', this.$firebase.user.uid)
      formData.append('format_id', this.formatid)
      formData.append('yaginame', '応募者')
      formData.append('app_flag', this.$site.appFlag)
      if (this.permissionType == 6) {
        formData.append('client_id', 'yagish_dir_saiyo')
      } else if (this.permissionType == 5) {
        formData.append('client_id', 'yagish_eigyo_saiyo')
      } else {
        formData.append('client_id', 'yagish_saiyo')
      }
      formData.append('dialog_name', 'yagish_dialog')
      formData.append('permission_type', this.permissionType)
      formData.append('filename', this.createFilename('pdf'))
      formData.append('device_flg', this.$deviceLib.isMobileDevice ? 'SP': 'PC')
      formData.append('version', '2')
      formData.append('reqflg', '2')
      const app = this
      this.$axios
        .post(this.$varuna.endPoints.yagishRecruitPdfMail, formData, {timeout: 60000})
        .then(function (response) {
          app.isYagishSended = true
          app.$eventHub.$emit('set_is_sendedYagishIntern', true)
        })
        .catch(function (error) {
          app.$message({
            message: '전송을 실패하였습니다.',
            type: 'error'
          })
          app.$gtm.sendError('pdf mail', `send pdf mail failed ${error}`)
        }).finally(function () {
          app.fullscreenLoading = false
        })
    }
  },
  beforeMount: function () {
    this.$eventHub.$on('send-yagish-consult', this.sendYagishConsult)
    this.$eventHub.$on('open-yagish-dialog', this.openYagishDialog)
    this.$eventHub.$on('popstate', this.closeYagishDialog)
  },
  destroyed: function () {
    this.$eventHub.$off('send-yagish-consult', this.sendYagishConsult)
    this.$eventHub.$off('open-yagish-dialog', this.openYagishDialog)
    this.$eventHub.$off('popstate', this.closeYagishDialog)
  }
}
</script>
